import { Button, Input, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { images } from '../../appCore';
import { eventBus, TRANSFORM_TOOLTIP } from '../../utils';
import SettingForm from '../SettingForm';

import { updateCommonSettings } from '../../redux/board/reducer';
import { setIsContentChange } from '../../redux/stateManager/reducer';
import './styles.scss';

const coordinates = ['x', 'y', 'width', 'height', 'scaleX', 'scaleY'];
const TransformComponent = () => {
  const dispatch = useDispatch();
  const commonSettings = useSelector((state) => state.board.commonSettings);
  const [value, setValue] = useState(commonSettings || null);
  const typeKeyMap = (type) => {
    const keyMap = {
      x: 'left',
      y: 'top',
      width: 'width',
      height: 'height',
      scaleX: 'scaleX',
      scaleY: 'scaleY',
      angle: 'angle',
    };
    return keyMap[type];
  };
  const onChange = (e, type) => {
    e.stopPropagation();
    e.target.value.replace(/[^0-9]\d-/g, '');
    if (['scaleX', 'scaleY', 'x', 'y'].includes(type) && parseFloat(e.target.value || 0) < 0) {
      e.target.value = parseFloat(e.target.value || 0).toString();
    }
    if (['angle'].includes(type)) {
      if (parseFloat(e.target.value || 0) < -360) {
        e.target.value = '0';
      }
      if (parseFloat(e.target.value || 0) > 360) {
        e.target.value = '360';
      }
    }
    const data = {
      ...value,
      [type]: parseFloat(e.target.value || 0),
      valueChange: undefined,
    };
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    const typeKey = typeKeyMap(type);
    eventBus.emit('on-transform-change', { [typeKey]: parseFloat(e.target.value || 0) });
    dispatch(updateCommonSettings(data));
  };

  const onFlip = (action) => {
    eventBus.emit('action-flip', action);
  };

  useEffect(() => {
    setValue(commonSettings);
  }, [commonSettings]);

  return (
    <div className="mo__transform-component">
      <div className="coordinates">
        {coordinates.map((item) =>
          !['scaleX', 'scaleY'].includes(item) ? (
            <div key={item}>
              <SettingForm
                className="custom"
                type="number"
                title={TRANSFORM_TOOLTIP[item]}
                onChange={(e) => onChange(e, item)}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                textTitle={item.charAt(0)}
                value={value[item] ? Math.round(value[item] * 100) / 100 : 0}
              />
            </div>
          ) : (
            ''
          ),
        )}
      </div>
      <div>
        <p className="title">Scale</p>
        <div className="coordinates">
          {coordinates.map((item) =>
            ['scaleX', 'scaleY'].includes(item) ? (
              <div key={item}>
                <SettingForm
                  className="custom"
                  type="number"
                  min={0}
                  title={TRANSFORM_TOOLTIP[item]}
                  onChange={(e) => onChange(e, item)}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                  textTitle={item.substring(item.length - 1).toLowerCase()}
                  value={value[item] ? Math.round(value[item] * 100) / 100 : 0}
                />
              </div>
            ) : (
              ''
            ),
          )}
        </div>
      </div>
      <div className="rotate">
        <p className="title">Rotate</p>
        <div className="coordinates">
          <Tooltip title="Rotation">
            <Input
              className="custom input"
              addonBefore={<img src={images.ANGLE} alt="" style={{ width: '15px' }} />}
              type="number"
              onChange={(e) => onChange(e, 'angle')}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              max={360}
              value={value && value.angle ? Math.round(value.angle * 100) / 100 : 0}
            />
          </Tooltip>
          <div className="button-group">
            <Tooltip title="Flip Horizontal">
              <Button onClick={() => onFlip('flipX')}>
                <img src={images.ROTATE_90} alt="" />
              </Button>
            </Tooltip>
            <Tooltip title="Flip Vertical">
              <Button onClick={() => onFlip('flipY')}>
                <img src={images.ROTATE_180} alt="" />
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransformComponent;
